import { render } from "./AuthWrapper.vue?vue&type=template&id=9c0c3992"
import script from "./AuthWrapper.vue?vue&type=script&lang=js"
export * from "./AuthWrapper.vue?vue&type=script&lang=js"

import "./AuthWrapper.vue?vue&type=style&index=0&id=9c0c3992&scope=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__